import React from "react";
import { string, object } from "prop-types";

import BigSectionName from "../../atoms/BigSectionName";
import SubSectionsMenuItems from "../../atoms/SubSectionsMenuItems";

import "./sectionMenuDom.m.css";

const ChildSectionDom = ({
  collection,
  pageType,
  domainSectionObj,
  domainSlug,
  sectionsDataForHeader,
  multiDomainWrapperName,
}) => {
  return collection.template === "section" ? (
    pageType === "section-page" ? (
      <nav styleName={`navbar ${multiDomainWrapperName ? `nav-${multiDomainWrapperName}` : ""}`} className="navbar">
        <ul styleName="parent-section" className="parent-section">
          {
            <BigSectionName
              domainSectionObj={domainSectionObj}
              domainSlug={domainSlug}
              sectionsDataForHeader={sectionsDataForHeader}
            />
          }
        </ul>
        {<SubSectionsMenuItems sectionsDataForHeader={sectionsDataForHeader} />}
      </nav>
    ) : (
      <nav styleName={`navbar ${multiDomainWrapperName ? `nav-${multiDomainWrapperName}` : ""}`} className="navbar">
        <ul styleName="parent-section" className="collection-name parent-section">
          <li className="collection">{collection.name}</li>
        </ul>
      </nav>
    )
  ) : (
    <nav styleName={`navbar ${multiDomainWrapperName ? `nav-${multiDomainWrapperName}` : ""}`} className="navbar">
      <ul styleName="parent-section" className="parent-section">
        <li className="section">{collection.name}</li>
      </ul>
    </nav>
  );
};

ChildSectionDom.propTypes = {
  collection: object,
  pageType: string,
  domainSectionObj: object,
  domainSlug: object,
  sectionsDataForHeader: object,
  multiDomainWrapperName: string,
};

export default ChildSectionDom;
